import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from '../components/common/Banner';
import ContactInfo from '../components/contact/ContactInfo';
import ContactForm from '../components/forms/ContactForm';
import MapSection from '../components/contact/MapSection';
import FAQSection from '../components/contact/FAQSection';
import NewsletterForm from '../components/forms/NewsletterForm';

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - KALS Academy</title>
        <meta name="description" content="Get in touch with KALS Academy. Contact information, inquiry form, location map, and frequently asked questions." />
      </Helmet>
      
      <Banner title="Contact Us" />
      <ContactInfo />
      <ContactForm />
      <MapSection />
      <FAQSection />
      <NewsletterForm />
    </>
  );
};

export default ContactPage;
